@use '@lib/assets/styles/main.scss' as *;

.root {
  position: relative;
}

.body {
  margin: -16px;
}

.rightDropDownIcon {
  color: $gray700;
}
